module.exports = __webpack_public_path__ + "1f70d42462c26a4ff2c0bb5b4b4a862f.png";